const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;
export const LcwMoneyCommand: any = {
    LcwMoneyCashInOut: Backofficebff + '/v1/lcwmoney/wallet-balance-update',
};
